import { withCompInfo } from '@wix/editor-elements-integrations'
import { SectionCss } from './Section'
import {
	getFillLayersColorsVars,
	getFillLayersCSSVars,
	getFillLayersMediaVars,
} from '../../core/mappers/FillLayers/FillLayers.utils'
import { getShapeDividersResponsiveCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import { getCompDesignPerVariant } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'

export const css = withCompInfo<SectionCss, any>()(
	[
		'compId',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'hasResponsiveLayout',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compId,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const compDesignPerVariantMap = getCompDesignPerVariant(compDesign)
		const defaultDesign = compDesignPerVariantMap['']
		const backgroundMedia = defaultDesign?.background
		const hasNoColorLayers = !backgroundMedia?.colorLayers

		const getBackgroundCSSVars = hasNoColorLayers ? getFillLayersCSSVars : getFillLayersMediaVars

		const fillLayersCSSVars = backgroundMedia
			? getBackgroundCSSVars({
					animations,
					backgroundMedia,
					compDesign,
					compProps,
					compId,
					experiments,
					isMobileView,
					isNonAdaptiveMobile,
					siteColors,
					viewMode,
			  })
			: {}

		return fillLayersCSSVars as SectionCss
	}
)

export const designCss = withCompInfo<any, any>()(
	['compId', 'compDesign', 'siteColors'],
	({ compId, compDesign, siteColors }) => {
		const backgroundMedia = compDesign?.background
		const hasColorLayers = backgroundMedia?.colorLayers
		const colorLayers = hasColorLayers
			? getFillLayersColorsVars({
					siteColors,
					backgroundMedia,
			  })
			: {}

		const shapeDividersCSSVars = getShapeDividersResponsiveCSSVars({
			compId,
			compDesign,
			colorsMap: siteColors,
		})

		return {
			...colorLayers,
			...shapeDividersCSSVars,
		}
	}
)
